module.exports = __webpack_public_path__ + "static/media/banner03.7770bcf1.jpg";